import {ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import {mergeMap, map, catchError} from 'rxjs/operators';
import { IEpicDependency, IAppError, IPaymentResults } from '../../models';
import { IAppAction } from '../app-action';
import { makePaymentError, makePaymentSuccess, paymentStateActions } from './payment-actions';
import { IAppState } from '../app-state';
import { sendToast, ToastType } from '../../helpers/sendToast';

export const confirmPaymentEpic = (action$: ActionsObservable<IAppAction>, state$: StateObservable<IAppState>, {api, endPointKeys}:
    IEpicDependency): Observable<IAppAction> => action$.pipe(
        ofType(paymentStateActions.CONFIRM_PAYMENT),
        mergeMap(action => {
            var data = JSON.stringify(action.payload);
            return api.post(endPointKeys.api_travel, 'payment', data).pipe(
                map(result => result.data),
                mergeMap((paymentResults: IPaymentResults) => {
                    return of(makePaymentSuccess(paymentResults));
                }),
                catchError(error => {
                    const appError : IAppError = { error, message: error.response.data.message};
                    sendToast(appError.message, ToastType.Error);
                    return of(makePaymentError(appError));
                }))
        })
    )